import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import BeatLoader from 'react-spinners/BeatLoader'
import styled from 'styled-components'

import { addToast } from 'components/Toast/Toast'
import { useDeleteTicket } from 'pages/support/service/react-query/useDeleteTicket/useDeleteTicket'

import { TicketCard } from './TicketCard/TicketCard'
import { type ITicket } from '../../../types/interfaces/ITicket'

interface ITicketWrapper {
    tickets: ITicket[]
    isLoading: boolean
}

export const TicketWrapper = ({
    tickets,
    isLoading
}: ITicketWrapper) => {
    const queryClient = useQueryClient()
    const { t } = useTranslation()

    const { mutate: deleteTicketMutation } = useDeleteTicket()

    const handleDeleteTicket = (ticket: ITicket) => {
        if (!ticket.public_id) {
            return
        }

        deleteTicketMutation(ticket.public_id, {
            onSettled: () => {
                queryClient.invalidateQueries('tickets')
            },
            onError: () => {
                addToast(
                    'error',
                    t('errorSomethingWentWrong')
                )
            }
        })
    }

    if (isLoading) {
        <BeatLoader size={8} />
    }

    return (
        <>
            {tickets.length > 0 ? (
                tickets.map((ticket: ITicket) => (
                    <TicketCard
                        key={ticket.public_id ?? `ticket-${ticket.id}`}
                        ticket={ticket}
                        handleDeleteTicket={handleDeleteTicket}
                    />
                ))
            ) : (
                <StyledNoText>
                    {t('noTickets')}
                </StyledNoText>
            )}
        </>
    )
}

const StyledNoText = styled.span`
    display: block;
    width: 100%;
    padding: 4rem 2rem;
    text-align: center;
    font-size: 1.6rem;
    font-weight: 500;
    opacity: 0.4;
`